import { HTMLAttributes } from 'react'

import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { mediaParallaxAnimation } from './animations'
import { cn } from '@/lib/utils'

export type MediaParallaxProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    media: MediaElement
    paragraph: string
    align: 'left' | 'right'
  }>

const MediaParallax = ({
  media,
  align,
  paragraph,
  className,
  ...props
}: MediaParallaxProps) => {
  return (
    <Motion animation={mediaParallaxAnimation}>
      {(motionRef) => (
        <Section
          ref={motionRef}
          className={cn('px-margin lg:px-0', className)}
          {...props}
        >
          <Grid>
            <div
              className={cn(
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:row-span-8 lg:row-start-3 lg:w-col-span-7',
                'grid grid-cols-7 items-end gap-x-gutter'
              )}
            >
              <div
                className={cn(
                  'relative col-span-2 aspect-[215/280]',
                  'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black/45',
                  {
                    'order-2': align === 'right'
                  }
                )}
                data-motion-align={align}
                data-motion-media
              >
                <Media fill fit="cover" {...media} />
              </div>

              <div
                className={cn(
                  'relative col-span-5',
                  'lg:mb-[18%]',
                  {
                    'z-10 order-1': align === 'right'
                  }
                  /* {
                    'lg:-translate-x-[15%]': align === 'left',
                    'lg:translate-x-[15%]': align === 'right'
                  } */
                )}
                data-motion-align={align}
                data-motion-paragraph
              >
                {paragraph ? (
                  <Typography
                    paragraph
                    className="text-[2.88rem] leading-[3.2rem] md:text-[3.6rem] md:leading-[4.2rem]"
                  >
                    {paragraph}
                  </Typography>
                ) : null}
              </div>
            </div>
          </Grid>
        </Section>
      )}
    </Motion>
  )
}

export default MediaParallax
